module.exports = __webpack_public_path__ + "static/hiking-2fb3eef86c403142cb195bbff2f0a01f.png";